import * as React from 'react';
import "./indices.scss";

const Indices = props => {
  const { data } = props;

  const renderItem = (label, value, color) => {
    return (
      <div className='item' style={{border: `1px solid ${color}`}}>
        <div className='label' style={{backgroundColor: color}}>{label}</div>
        <div className='value'>{value}</div>
      </div>
    )
  }

  return (
    <div className='indices'>
      {renderItem("H", data && data.hindex || 0, "#bfc8b1")}
      {renderItem("A", data && data.activity.toFixed(2) || 0, "#c6bda4")}
      {renderItem("S", data && data.sociability.toFixed(2) || 0, "#a0bdc6")}
      {renderItem("C", data && data.citations || 0, "#b0bbd9")}
      {renderItem("P", data && data.pubs || 0, "#acc0bf")}
    </div>
  )
}

export default Indices;